(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay/assets/javascripts/communication/app-notifications.js') >= 0) return;  svs.modules.push('/components/tur/pay/assets/javascripts/communication/app-notifications.js'); 
'use strict';

function appNotifications(_ref) {
  let {
    next,
    notifications
  } = _ref;
  if (notifications) {
    if (!Array.isArray(notifications)) {
      notifications = [notifications];
    }
    notifications.forEach(notification => {
      svs.components.app_notifications.setUpAppNotifications(notification);
    });
  }
  next();
}
svs.tur.pay.communication.appNotifications = appNotifications;
 })(window);